function dirname(path) {
    return path.replace(/\\/g, "/").replace(/\/[^/]*$/, "");
}
function basename(path) {
    return path.replace(/\\/g, "/").replace(/.*\//, "");
}
function isHiddenFile(filename) {
    const base = basename(filename);
    return base.startsWith(".") || [
        "desktop.ini"
    ].indexOf(base.toLowerCase()) > -1;
}
export { dirname, basename, isHiddenFile };
